export default __webpack_public_path__ + "static/media/cutout-cookie.ddbea471.png";